module.exports = __webpack_public_path__ + "img/Canada-cover.cf4c9db8.jpg";